t<template>
  <div class="calculator-wrapper">
    <div class="calculator">
      <CalculatorHeading :step="step"></CalculatorHeading>
      <CountImageInput
        :question="$t('music.question')"
        :counter.sync="music"
        :image="require('@/assets/sonos.jpg')"
      >
      </CountImageInput>
      <one-button type="primary" class="next-btn" @click.native="next()">
        {{ $t('next') }}
      </one-button>
      <a @click="$router.push(getPrevStepUrl(step, $i18n.locale))" class="back-btn"
        >{{ $t('back') }}</a
      >
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import CountImageInput from "../../components/CountImageInput";
import CalculatorHeading from "../../components/CalculatorHeading";
import {
  getStepIndex,
  redirectToUnselectedStepIfAny,
  getPrevStepUrl,
  getNextStepUrl
} from "@/utils/steps.js";

export default {
  name: "Displays",
  components: { CalculatorHeading, CountImageInput },
  data() {
    return {
      step: getStepIndex("music"),
      getPrevStepUrl: getPrevStepUrl,
      music: this.$store.state.data.music
    };
  },
  watch: {
    music: function() {
      this.updateMusic(this.music);
    }
  },
  mounted() {
    redirectToUnselectedStepIfAny(
      this.step,
      this.$store.state.data,
      this.$router,
      this.$i18n.locale
    );
  },
  methods: {
    ...mapMutations(["updateMusic"]),
    next() {
      setTimeout(() => this.$router.push(getNextStepUrl(this.step, this.$i18n.locale)), 200);
    }
  }
};
</script>

<style scoped>
.calculator {
  align-items: center;
}
</style>
